import {
  actionTypes,
  buyPolicyActionType,
  insuranceProviderActions,
  motorActionTypes,
  notificationActions,
  updateTour,
} from 'src/actions/actionTypes'
import { FILTER_ACTIONS } from 'src/reducers/reducerConstants'

export * from './buyInsuranceLifeActions'

export const increment = () => {
  return {
    type: 'INCREMENT',
  }
}
export const showsxp = () => {
  return {
    type: 'SHOWSXP',
  }
}
export const merged = () => {
  return {
    type: 'MERGED',
  }
}

export const userinfo = (profile) => {
  return {
    type: 'USERINFO',
    payload: profile,
  }
}
export const registeruserinfo = (profile) => {
  return {
    type: 'REGISTERUSERINFO',
    payload: profile,
  }
}

export const username = (name) => {
  return {
    type: 'USERNAME',
    payload: name,
  }
}

// Buy Policy Health Actions Start

export const updateUserDetails = (userDetails) => {
  return {
    type: actionTypes?.UPDATE_USER_DETAILS,
    payload: userDetails,
  }
}

export const updateMemberDetails = (memberDetails) => {
  return {
    type: actionTypes?.UPDATE_MEMBER_DETAILS,
    payload: memberDetails,
  }
}

export const updateNomineeDetails = (memberDetails) => {
  return {
    type: actionTypes?.UPDATE_NOMINEE_DETAILS,
    payload: memberDetails,
  }
}

export const updateProposerDetails = (details) => {
  return {
    type: actionTypes?.UPDATE_PROPOSER_DETAILS,
    payload: details,
  }
}

export const updateToken = (token) => {
  return {
    type: actionTypes?.UPDATE_TOKEN,
    payload: token,
  }
}

export const updateSelectedQuote = (selectedQuote) => {
  return {
    type: actionTypes?.UPDATE_SELECTED_QUOTE,
    payload: selectedQuote,
  }
}

export const updateFullQuote = (fullQuote) => {
  return {
    type: actionTypes?.UPDATE_FULL_QUOTE,
    payload: fullQuote,
  }
}

export const updateQuickQuoteFilters = (filters) => {
  return {
    type: actionTypes?.UPDATE_QUICK_QUOTE_FILTERS,
    payload: filters,
  }
}

export const updateProviderDetails = (providerDetails) => {
  return {
    type: actionTypes?.UPDATE_PROVIDER_DETAILS,
    payload: providerDetails,
  }
}
export const updateTrust = (trust) => {
  return {
    type: actionTypes?.UPDATE_TRUST,
    payload: trust,
  }
}

export const updateSelectedFullQuote = (selectedFullQuote) => {
  return {
    type: actionTypes?.UPDATE_SELECTED_FULL_QUOTE,
    payload: selectedFullQuote,
  }
}

export const updatePaymentLink = (paymentLink) => {
  return {
    type: actionTypes?.UPDATE_PAYMENT_LINK,
    payload: paymentLink,
  }
}

export const updateKycLink = (kycLink) => {
  return {
    type: actionTypes?.UPDATE_KYC_LINK,
    payload: kycLink,
  }
}

export const updatePlanDetailsQuote = (planDetailsQuote) => {
  return {
    type: actionTypes?.UPDATE_PLAN_DETAILS_QUOTE,
    payload: planDetailsQuote,
  }
}

export const updatePlanDetails = (planDetails) => {
  return {
    type: actionTypes?.UPDATE_PLAN_DETAILS,
    payload: planDetails,
  }
}
export const addToCompareList = (quote) => {
  return {
    type: actionTypes?.ADD_TO_COMPARE,
    payload: quote,
  }
}
export const removeFromCompareList = (quote) => {
  return {
    type: actionTypes?.REMOVE_FROM_COMPARE,
    payload: quote,
  }
}

export const clearCompareList = () => {
  return {
    type: actionTypes?.CLEAR_COMPARE_LIST,
  }
}

export const updatePolicyTenurePeriod = (tenure) => {
  return {
    type: actionTypes?.UPDATE_POLICY_TENURE,
    payload: tenure,
  }
}

export const updateOldPolicyId = (oldPolicyId) => {
  return {
    type: actionTypes?.UPDATE_OLD_POLICY_ID,
    payload: oldPolicyId,
  }
}

export const clearGuestDetails = () => {
  return {
    type: actionTypes?.CLEAR_STATE,
  }
}
// Buy Policy Health Actions End
export const updateTokenMotor = (token) => {
  return {
    type: motorActionTypes?.UPDATE_TOKEN_MOTOR,
    payload: token,
  }
}

export const updateVehicleDetailsMotor = (vehicleDetails) => {
  return {
    type: motorActionTypes?.UPDATE_VEHICLE_DETAILS,
    payload: vehicleDetails,
  }
}

export const updatePersonalDetailsMotor = (personalDetails) => {
  return {
    type: motorActionTypes?.UPDATE_PERSONAL_DETAILS,
    payload: personalDetails,
  }
}

export const updatePreviousPolicyDetailsMotor = (previousPolicyDetails) => {
  return {
    type: motorActionTypes?.UPDATE_PREVIOUS_POLICY_DETAILS,
    payload: previousPolicyDetails,
  }
}

export const updateCurrentPolicyDetailsMotor = (currentPolicyDetails) => {
  return {
    type: motorActionTypes?.UPDATE_CURRENT_POLICY_DETAILS,
    payload: currentPolicyDetails,
  }
}

export const updateMotorQuote = (quote) => {
  return {
    type: motorActionTypes?.UPDATE_SELECTED_QUOTE,
    payload: quote,
  }
}

export const updateMotorNomineeDetails = (nominee) => {
  return {
    type: motorActionTypes?.UPDATE_NOMINEE_DETAILS,
    payload: nominee,
  }
}

export const updateSelectedQuoteMotor = (selectedQuote) => {
  return {
    type: motorActionTypes?.UPDATE_SELECTED_QUOTE,
    payload: selectedQuote,
  }
}

export const updatePACoverArray = (paArray) => {
  return {
    type: motorActionTypes?.UPDATE_PA_COVER,
    payload: paArray,
  }
}

export const updateMotorDetails = (motorDetails) => {
  return {
    type: motorActionTypes?.UPDATE_MOTOR_DETAILS,
    payload: motorDetails,
  }
}

export const updateIsVehiclePrefilledData = (isVehiclePrefilledData) => {
  return {
    type: motorActionTypes?.UPDATE_IS_VEHICLE_PREFILLED_DATA,
    payload: isVehiclePrefilledData,
  }
}

/* Tour Actions Start here*/

export const setRiskScoreTour = (setTour) => {
  return {
    type: updateTour?.START_RISK_SCORE_TOUR,
    payload: setTour,
  }
}

export const setRiskScoreTourPopup = (setTour) => {
  return {
    type: updateTour?.START_RISK_SCORE_TOUR_POPUP,
    payload: setTour,
  }
}

export const setPolicyTileCardTour = (setTour) => {
  return {
    type: updateTour?.START_POLICY_TILE_CARD_TOUR,
    payload: setTour,
  }
}

export const setInsuranceDetailsTour = (setTour) => {
  return {
    type: updateTour?.START_INSURANCE_DETAILS_TOUR,
    payload: setTour,
  }
}

export const setRiskScoreTourForInput = (setTour) => {
  return {
    type: updateTour?.START_RISK_SCORE_INPUT_TOUR,
    payload: setTour,
  }
}

/* Tour Actions End here*/

export const setDashboardFilters = (type, filters) => {
  return {
    type,
    payload: filters,
  }
}

/* Notification Actions Start here*/

export const showNotificationMessage = (notification) => {
  return {
    type: notificationActions?.SHOW_NOTIFICATION,
    payload: notification,
  }
}

/* Notification Actions End here*/

export const insuranceProvider = (list) => {
  return {
    type: insuranceProviderActions?.INSURANCE_PROVIDER_LIST,
    payload: list,
  }
}

// filter actions - expired

export const setYear = (year) => ({
  type: FILTER_ACTIONS?.SET_YEAR,
  payload: year,
})

export const setPolicyType = (policyType) => ({
  type: FILTER_ACTIONS?.SET_POLICY_TYPE,
  payload: policyType,
})

export const setSubType = (subType) => ({
  type: FILTER_ACTIONS?.SET_SUB_TYPE,
  payload: subType,
})

export const resetFilters = () => ({
  type: FILTER_ACTIONS?.RESET_FILTERS,
})

export const setSelectedInsurance = (insurance) => ({
  type: FILTER_ACTIONS?.SET_SELECTED_INSURANCE,
  payload: insurance,
})

export const setClearState = (clearState) => ({
  type: FILTER_ACTIONS?.SET_CLEAR_STATE,
  payload: clearState,
})

export const updateBuyPolicyTitle = (title) => {
  return {
    type: buyPolicyActionType?.UPDATE_BUY_POLICY_TITLE,
    payload: title,
  }
}
